module.exports = __webpack_public_path__ + "static/media/ps.f0d9916c.svg";